// LIBS
import React from 'react'
import {get} from 'lodash/fp'
import {format} from 'date-fns'

// INTERFACE
export default ({blogPost}) => {
  let imageSrc = get('imageHeader.fields.file.url', blogPost)
  let imageAlt = get('image.fields.description', blogPost)
  let authorName = get('blogAuthor.fields.name', blogPost)
  let authorSlug = '/' + get('blogAuthor.fields.slug', blogPost)
  return (
    <div itemID={'/' + blogPost.slug} itemScope itemType="http://schema.org/LiveBlogPosting" className='LegacyPost stub'>
      <div style={{ maxHeight: '400px', overflow: 'hidden'}} className='blog-subheader'>
        <img itemProp='image' style={{width: '100%'}} src={imageSrc} alt={imageAlt} />
      </div>
      <div className='container blog-content'>
        <div className="col-md-8 col-md-offset-2 blog_content">
          <h2 itemProp='headline'>{blogPost.title}</h2>
          <p className="author_name">By <a itemScope itemProp="Person" itemType="http://schema.org/Person" href={authorSlug}><span itemProp='name'>{authorName}</span></a> on <span  itemProp="datePublished" content={blogPost.createdAt}>{format(blogPost.createdAt, 'MMMM D, YYYY')}</span></p>
          <p itemProp='description' className="intro" dangerouslySetInnerHTML={{ __html: blogPost.intro }} />
          <link itemProp='sameAs' href={'/' + blogPost.slug} />
          <a className="btn btn-primary" href={'/' + blogPost.slug}>READ MORE</a>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/blog-post-item/index.js